import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getFrecuencia = async (accessToken) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`
}

const url = `${apiUrl}Formularios/spTablero_GetFrecuencia`

return fetch(url, { headers })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(error => console.log('Error:', error));

}

const updateFrecuencia = async (nuevaFrecuencia, accessToken) => {

  const url = `${apiUrl}Formularios/spTablero_UpdateFrecuencia`;
  
    const data = {
      spTablero_UpdateFrecuenciaRequest: {
        NuevaFrecuencia: nuevaFrecuencia
      },
    };
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        return { success: true, message: 'Actualización exitosa' };
      } else {
        console.error('Error en la respuesta:', response.status, response.statusText);
        return { success: false, message: 'Falló la actualización' };
      }
    } catch (error) {
      console.error('Error en UpdateGroup:', error.message);
      throw error;
    }
}

const getDataForDashboard = async (accessToken) => {
    
    const headers = {
        Authorization: `Bearer ${accessToken}`
    }
    
    const url = `${apiUrl}Formularios/GetInfoTablero` 

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
    
}

export { getDataForDashboard, getFrecuencia, updateFrecuencia }